/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 10/15/2019
 *
 */

/**
 * all optional icons appears in the header
 * @title - the name appears when hover
 * @iconClassName - icon font awesome name
 * @emitterName - event emitter name
 * @emitterValue - default value fot e event emitter
 */

const optionalIconsConfig = {
    manageColumnsIcon: {
        title: 'Manage Table Columns',
        iconClassName: 'fa fa-lg fa-columns',
        ariaLabel: 'Manage Table Columns',
        emitterName: 'openTableColumnViewer',
        emitterValue: true
    },
    saveIcon: {
        title: 'Save',
        iconClassName: 'fa fa-lg fa-save',
        ariaLabel: 'Save',
        emitterName: 'saveFormData',
        emitterValue: true
    },
    deleteIcon: {
        title: 'Delete',
        iconClassName: 'fa fa-lg fa-trash',
        ariaLabel: 'Save',
        emitterName: 'displayDeleteFormDataWarning',
        emitterValue: true
    },
    backIcon: {
        title: 'Back',
        iconClassName: 'fa fa-lg fa-arrow-left',
        ariaLabel: 'Back',
        emitterName: 'navigateToPreviousPage',
        emitterValue: true
    },
    clearFormIcon: {
        title: 'Clear Form',
        iconClassName: 'fa fa-lg fa-eraser',
        ariaLabel: 'Clear Form',
        emitterName: 'clearForm',
        emitterValue: true
    }
};

export default optionalIconsConfig;
